//import slick from "../../node_modules/slick-carousel";
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'
import companyAwardsHonors from '../components/company-awards-honors.svelte'
import Popup from '../components/team-popup.svelte'

import BigPicture from 'bigpicture'

const { $ } = window

export default {
	init() {
		const $imgCarousel = $('#imgCarousel')
		if ($imgCarousel.length) {
			tns({
				//animateIn: tns-fadeIn,
				//animateOut: tns-fadeOut,
				autoplay: true,
				autoplayTimeout: 2000,
				container: '#imgCarousel',
				controls: false,
				items: 5,
				lazyload: true,
				loop: true,
				responsive: {
					1300: {
						//edgePadding: 20,
						gutter: 30,
						items: 7,
					},
					1300: {
						//edgePadding: 20,
						gutter: 30,
						items: 4,
					},
					700: {
						items: 3,
						edgePadding: 20,
					},
					500: {
						items: 2,
						edgePadding: 20,
					},
					310: {
						items: 1,
						edgePadding: 20,
					},
				},
				slideBy: 1,
				speed: 1000,
				touch: false,
			})
		}

		let $compAHAnchor = $('#about-awards-honors-anchor')
		if ($compAHAnchor) {
			new companyAwardsHonors({
				target: $compAHAnchor[0],
				props: $compAHAnchor.data(),
			})
		}
		if ($imgCarousel.length) {
			$('.img-carousel').on('click', function (e) {
				BigPicture({
					el: e.target,
					gallery: '.img-carousel',
					loop: true,
					noLoader: true,
				})
			})
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		new Popup({
			target: document.body,
		})
	},
}
